import { default as MuiTableCell, TableCellProps } from '@mui/material/TableCell'
import * as React from 'react'

export const TableCell = React.forwardRef<HTMLElement, TableCellProps>((props, ref) => {
  return <MuiTableCell ref={ref} {...props} />
})

export default TableCell
